(function(doc, win){
	var supportPseudo = function () {
		var ss = doc.styleSheets[0];
		return function (pseudoClass){
			try {
				ss.insertRule("html" + pseudoClass + "{}", 0);
				ss.deleteRule(0);
				return true;
			}
			catch (e) {
				return false;
			}
		};
	}();

	//Polyfill for IE
	if (!Element.prototype.matches) {
		Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
	}

	if (!supportPseudo(":focus-within")) {
		var subs = $(".sub-menu");
		var focusWithinRegex = / focus-within/g;
		var focusWithinOn = function(e) {
			var parentNode = this.parentNode;
			this.setAttribute("class", (this.getAttribute("class") || "") + " focus-within");
			parentNode.setAttribute("class", (parentNode.getAttribute("class") || "").replace(focusWithinRegex, "") + " focus-within");
			this.removeEventListener("focus", focusWithinOn, true);
			this.addEventListener("blur", focusWithinOff, true);
		};
		var focusWithinOff = function(e) {
			var relatedTarget = e.relatedTarget;
			if (!this.contains(relatedTarget)) {
				this.setAttribute("class", (this.getAttribute("class") || "").replace(focusWithinRegex, ""));
				var parentNode = this.parentNode;
				if (!parentNode.contains(relatedTarget)) {
					parentNode.setAttribute("class", (parentNode.getAttribute("class") || "").replace(focusWithinRegex, ""));
				}
				this.removeEventListener("blur", focusWithinOff, true);
				this.addEventListener("focus", focusWithinOn, true);
			}
		};
		for (var i = 0, l = subs.length; i < l; i++) {
			subs[i].addEventListener("focus", focusWithinOn, true);
		}
	}
	win.onload = function() {
		doc.documentElement.setAttribute("class", "loaded");
	};
	// in browsers that don't have fetch, just let the form submit as usual
	if (win.fetch) {
		var euc = encodeURIComponent;
		function submitContact(e){
			var element = this;
			var els = element.querySelectorAll("input, select, textarea");
			var fields = [];
			for(var i = 0, l = els.length; i < l; i++){
				var el = els[i];
				fields.push(euc(el.name) + "=" + euc(el.value));
			}
			var request = new Request(element.action, {"method": element.method, "body": fields.join("&"),
				// "mode": "no-cors",
				"headers": {
					"Content-Type": "application/x-www-form-urlencoded; charset=utf-8"
				}
			});
			fetch(request).then(function(response) {
				response.text().then(function(text){
					element.parentNode.innerHTML = text;
				});
			}).catch(function(error) {
				//console.error(error);
			});

			e.preventDefault();
		}
		var forms = $(".contact-form");
		for(var i = 0, l = forms.length; i < l; i++){
			forms[i].addEventListener("submit", submitContact);
		}
	}

	// BEGIN PAGINATION
	var nextButton = $(".pagination a[aria-label='Next']")[0];
	if(nextButton) {
		var ABORT_MESSAGE = 'Aborted';
		function get(url, callback) {
			var xhr = new XMLHttpRequest();
			xhr.open("GET", url);
			xhr.addEventListener('load', function() {
				callback(null, xhr);
			});
		
			xhr.addEventListener('error', function() {
				callback(xhr, null);
			});
		
			xhr.addEventListener('abort', function() {
				callback(ABORT_MESSAGE, xhr);
			});

			xhr.send();

			return xhr.abort.bind(xhr);
		}
		var fetching, pageTimeout;
		nextButton.addEventListener("click", function fetchNextPage(e){
			if(fetching){
				try {
					fetching.abort();
				}
				catch(e) {

				}
				fetching = null;
			}
			clearTimeout(pageTimeout);

			var href = this.href;
			fetching = get(href, function(err, data) {
				if (err) {
					if (err !== ABORT_MESSAGE) { // ignore aborts
						pageTimeout = setTimeout(fetchNextPage, 10000, e); // try again in 10 seconds
					}
				}
				else {
					var div = document.createElement("div");
					div.innerHTML = data.response;
					var newPaginationLink = $(".pagination li:not([class=\"disabled\"]) a[aria-label=\"Next\"]", div)[0];
					var newPosts = $(".article-list > ul:first-of-type li", div);
					var liveContainer = $(".article-list > ul:first-of-type")[0];

					for(var i = 0, l = newPosts.length; i < l; i++) {
						liveContainer.appendChild(newPosts[i]);
					}
					
					if (newPaginationLink) {
						nextButton.href = newPaginationLink.href;
					}
					else {
						nextButton.style.display = "none";
					}
				}
			});

			e.preventDefault();
		});
	}

	//PolyFill for IE. Note that we already Polyfilled Matched above.
	if (!Element.prototype.closest) {
		Element.prototype.closest = function(s) {
			var el = this;
		
			do {
				if (el.matches(s)) return el;
				el = el.parentElement || el.parentNode;
			} while (el !== null && el.nodeType === 1);
			return null;
		};
	}

	// BEGIN EXPANDO CARD HANDLERS
	if(document.location.hash){
		var activeCard = $(document.location.hash + " + .expando-card")[0];
		if(activeCard){
			activeCard.setAttribute("class", (activeCard.getAttribute("class") || "") + " active");
		}
	}
	var expandoCards = $(".expando-cards");
	for(var i = 0, l = expandoCards.length; i < l; i++){
		(function(card){
			card.addEventListener("click", function(e){
				var anchor = e.target.closest("a");
				if (anchor.matches(".expando-card")){
					if(!anchor.hash) return;
					var old = $(".expando-card.active", card);
					if(old[0]){
						old[0].setAttribute("class", anchor.getAttribute("class").replace(/ active/g, ""));
					}
					var href = anchor.href;
					if(old[0] !== anchor){
						anchor.setAttribute("class", anchor.getAttribute("class") + " " + "active");
					}
					else {
						document.location.hash = href;
					}
					if (win.history.pushState) {
						win.history.pushState(null, null, href);
					}
					else {
						document.location.hash = href;
					}
					e.preventDefault();
				}
			});
		}(expandoCards[i]));
	}
	
	// BEGIN FADE IN EFFECT
	// fade elements into view when they come into focus.
	function isScrolledIntoView(el) {
		var rect = el.getBoundingClientRect();
		var elemTop = rect.top;
		var elemBottom = rect.bottom;
	
		// Only completely visible elements return true:
		//var isVisible = elemTop >= 0 && elemBottom <= win.innerHeight;
		// Partially visible elements return true:
		var isVisible = elemTop < win.innerHeight && elemBottom >= 0;
		return isVisible;
	}
	var scrollers = $(".fade-down-target");
	var l = scrollers.length;
	var ticking= false;
	function checkTargets() {
		var counter = 0;
		for(var i = 0; i < l; i++){
			var scroller = scrollers[i];
			if(!scroller.matches(".do-fade-down,.fade-down-pending") && isScrolledIntoView(scroller)){
				if (scroller.classList) {
					counter++;
					scroller.classList.add("fade-down-pending");
					setTimeout(function(who, klass){ who.classList.add(klass); who.classList.remove("fade-down-pending"); }, (counter + 1) * 150, scroller, "do-fade-down");
				}
			}
		}
		ticking = false;
	}
	checkTargets();
	// BEGIN STICKY HEADER
	var stickied = false;
	var stickyHeader = $(".nav-container")[0];
	var headerScroll = stickyHeader && stickyHeader.classList ? function(){
		var scrollY = win.scrollY === undefined ? window.pageYOffset : win.scrollY;
		if (scrollY > 210) {
			if(!stickied) {
				stickyHeader.classList.toggle('sticking', true);
				stickied = true;
			}
		}
		else if (stickied && scrollY < 150) {
			stickyHeader.classList.toggle('sticking', false);
			stickied = false;
		}
	} : function(){};

	win.addEventListener("scroll", function(e) {
		if (!ticking) {
			win.requestAnimationFrame(checkTargets);
			ticking = true;
		}
		headerScroll();
	});

	// BEGIN GOOGLE ANALYTICS
	win.ga=function(){ga.q.push(arguments);};
	ga.q=[];
	ga.l=+new Date;

	var GA_LOCAL_STORAGE_KEY = 'ga:clientId';
	if (win.localStorage) {
		ga('create', 'UA-46627754-1', {
			'storage': 'none',
			'clientId': localStorage.getItem(GA_LOCAL_STORAGE_KEY)
		});
		ga(function(tracker) {
			localStorage.setItem(GA_LOCAL_STORAGE_KEY, tracker.get('clientId'));
		});
	}
	else {
		ga('create', 'UA-46627754-1', 'auto');
	}
	ga('send','pageview');

	function createScript(src, callback){
		var script = document.createElement("script");
		script.src = src;
		callback && (script.onload = callback);
		script.setAttribute("async", "");
		doc.body.appendChild(script);
	}

	createScript("https://www.google-analytics.com/analytics.js");

	// relaxx animation library
	// relaxx is pretty optimized, but this comes at a cost...
	// if we run relaxx before the page is done loading fonts, images, or whatever else might jostle the page around
	// it doesn't notice these changes and will just use it's original values for element position and size. So... we need to wait for the
	// window's load event (which might happen before OR after the script is done loading, since we load the script asynconously)
	function relaxx() {
		// if we've already been called, don't do anything
		// if we don't have Rellax, don't do anything
		// if the document isn't ready, don't do anything
		if (relaxx.called || !win.Rellax || doc.readyState !== "complete") return;
		// otherwise, do things!
		relaxx.called = true;
		new Rellax(".hero-bg-container img", {"center": true, "speed": 1.5});
		if(doc.body.classList){
			setTimeout(function(){
				document.body.classList.add("rellax-loaded");
			}, 1250);
		}
	}
	createScript("/js/95b6bdeb.js", relaxx);
	win.addEventListener("load", relaxx);
}(document, window));